module.exports = __webpack_public_path__ + "img/promo-4.7e68c1fe.png";